/* ============================================================
   PRODUCT MODAL COMPONENT
   ============================================================ */
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);

        const content = this.querySelector('.product-media-modal__content');
        if (content) {
          // hide content immediately
          content.style.opacity = '0';
        }

        // run showActiveMedia first
        this.showActiveMedia();

        // show content only after 1 second
        setTimeout(() => {
          if (content) {
            content.style.opacity = '1';
          }
        }, 500);
      }


      showActiveMedia() {
        const openerMediaId = this.openedBy?.getAttribute('data-media-id');

        const allMedia = this.querySelectorAll('[data-media-id]');

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${openerMediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${openerMediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) {
          const leftPos = (activeMedia.width - container.clientWidth) / 2;
          container.scrollLeft = leftPos;
        }

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}


/* ============================================================
   MODAL SLICK SLIDER HANDLING
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {

  const selector = '.product-media-modal__content';
  let isUpdating = false;
  let reinitTimeout = null;

  /* ============================================================
     ACTIVE SYNC FUNCTION
     ============================================================ */
  function syncActiveMedia() {
    const modal = document.querySelector('product-modal');
    if (!modal) return;

    const openerMediaId = modal.openedBy?.getAttribute('data-media-id');
    if (!openerMediaId) return;

    const allMedia = modal.querySelectorAll('[data-media-id]');
    if (allMedia.length === 0) return;

    allMedia.forEach((el) => {
      if (el.getAttribute('data-media-id') === openerMediaId) {
        el.classList.add('active');
      } else {
        el.classList.remove('active');
      }
    });

    const activeMedia = modal.querySelector(`[data-media-id="${openerMediaId}"]`);
    if (!activeMedia) return;

    activeMedia.scrollIntoView({ behavior: 'instant', block: 'nearest' });

    const container = modal.querySelector('[role="document"]');
    if (container) {
      const leftPos = (activeMedia.width - container.clientWidth) / 2;
      container.scrollLeft = leftPos;
    }

    // console.log('[ACTIVE] Synced active media using data-media-id:', openerMediaId);
  }


  /* ============================================================
     DESTROY
     ============================================================ */
  function destroy() {
    const $el = $(selector);
    
    if ($el.hasClass('slick-initialized')) {
      $el.slick('unslick');
      // console.log('[SLICK] Destroyed');
    }
  }

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    const $el = $(selector);
    if ($el.length === 0) return;

    if ($el.children().length <= 1) {
      if ($el.hasClass('slick-initialized')) $el.slick('unslick');
      return;
    }

    if ($el.hasClass('slick-initialized')) return;

    const $activeImg = $el.find('img.active');
    let startIndex = 0;

    if ($activeImg.length) {
      const allChildren = $el.children();
      const $activeParent = $activeImg.closest($el.children());
      startIndex = allChildren.index($activeParent);
      // console.log('[SLICK] Found active image at index:', startIndex);
    }

    $el.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: true,
      adaptiveHeight: true,
      initialSlide: startIndex,
      prevArrow: `<button type="button" class="slick-prev" aria-label="Previous">
        <svg class="icon icon-caret" viewBox="0 0 10 6" style="transform: rotate(90deg);">
          <path fill="currentColor" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"></path>
        </svg>
      </button>`,
      nextArrow: `<button type="button" class="slick-next" aria-label="Next">
        <svg class="icon icon-caret" viewBox="0 0 10 6">
          <path fill="currentColor" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"></path>
        </svg>
      </button>`
    });

    // console.log('[SLICK] Initialized with starting slide:', startIndex);

    syncActiveMedia();
  }

  /* Initial init */
  init();


  /* ============================================================
     MUTATION OBSERVER
     ============================================================ */
  const target = document.querySelector(selector);
  if (!target) return;

  const obs = new MutationObserver((mutations) => {

console.log('[OBS] Something changed');

const modal = document.querySelector('.product-media-modal__content');
if (modal) {
  const btn = document.querySelector('button.product__media-zoom-lightbox');
  const btnMediaId = btn?.getAttribute('data-media-id');

  if (btnMediaId) {
    const matchImg = modal.querySelector(`[data-media-id="${btnMediaId}"]`);

    if (matchImg) {
      console.log('[MATCHED IMG]', matchImg);

      // STOP OBSERVER to prevent infinite loop
      obs.disconnect();

      // remove active from all
      modal.querySelectorAll('img[data-media-id]').forEach((img) => {
        img.classList.remove('active');
      });

      // add active to matched
      matchImg.classList.add('active');

      // RESTART OBSERVER
      obs.observe(modal, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }
}


    if (isUpdating) {
      // console.log('[OBS] Skipped because isUpdating = true');
      return;
    }

    let activeClassChanged = false;

    for (const mutation of mutations) {
      // console.log('[OBS] Mutation detected:', mutation);

      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const el = mutation.target;
        // console.log('[OBS] Attribute changed on:', el);

        if (el.tagName === 'IMG' && el.classList.contains('active')) {
          activeClassChanged = true;
          // console.log('[OBS] IMG got active class');
          break;
        }
      }

      if (mutation.type === 'childList') {
        // console.log('[OBS] childList change detected');
        activeClassChanged = true;
        break;
      }
    }

    if (!activeClassChanged) {
      // console.log('[OBS] No active-related mutation. Ignoring.');
      return;
    }

    if (reinitTimeout) {
      // console.log('[OBS] Clearing previous reinit timeout');
      clearTimeout(reinitTimeout);
    }

    // console.log('[OBS] Scheduling slick reinit...');
    reinitTimeout = setTimeout(() => {
      // console.log('[OBS] Running reinit process...');
      isUpdating = true;

      obs.disconnect();
      // console.log('[OBS] Observer disconnected');

      destroy();
      init();
      syncActiveMedia();

      obs.observe(target, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });

      // console.log('[OBS] Observer reconnected');
      isUpdating = false;

      // console.log('[SLICK] Reinitialized after change');
    }, 100);
  });

  obs.observe(target, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });

  // console.log('[OBS] MutationObserver initialized');


  /* ============================================================
     REINIT ON MODAL OPEN
     ============================================================ */
  document.addEventListener('modalOpened', (event) => {
    const modal = event.detail.modal;
    if (!modal.querySelector(selector)) return;

    setTimeout(() => {
      destroy();
      init();
      syncActiveMedia();
      // console.log('[SLICK] Reinit + active synced after modalOpened');
    }, 50);
  });

});
